<template>
  <div>
    <div class="app-main__inner">
      <TituloComponente
        icono-titulo="fas fa-clipboard-list"
        texto-titulo="Conceptos"
        :to-create-action="{name:'NuevoConcepto'}"
        to-create-text="Nuevo Concepto"
      />
      <div class="tab-content">
        <div class="tab-pane tabs-animation fade show active" id="tab-content-0" role="tabpanel">
          <div class="row">
            <div class="col-lg-12">
              <div class="main-card mb-3 card">
                <div class="card-body">
                  <h5 class="card-title">Listado de conceptos</h5>
                  <DataList
                    ref="datatable"
                    url="/conceptos"
                    :fields="fields"
                    :rowClick="mostrarOpciones"
                  ></DataList>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponente from "@/components/layouts/TituloComponente";
import axios from "axios";
import DataList from "@/components/layouts/DataList";
import Swal from "sweetalert2";
export default {
  name: "ListarConceptos",
  components: {
    TituloComponente,
    DataList,
  },
  data() {
    return {
      concepto: [],
      fields: [
        {
          name: "codigo",
          label: "",
          type: "title",
          class: "text-alternate",
          append: "-"
        },
        {
          name: "descripcion",
          label: "",
          type: "title",
          class: "text-primary",
        },
        {
          name: "tipo",
          label: "Tipo",
          type: "field",
          class: "text-secondary",
        },
        {
          name: "codigo_afip",
          label: "Código AFIP",
          type: "field",
          class: "text-secondary",
        },
      ],
      loading: false,
    };
  },
  created() {},
  mounted() {},
  methods: {
    mostrarOpciones(concepto) {
      Swal.fire({
        title: concepto.descripcion,
        showCancelButton: true,
        confirmButtonText: "Editar",
        cancelButtonText: "Eliminar",
        confirmButtonColor: "#f7b924",
        cancelButtonColor: "#d33",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.$router.push({
            name: "EditarConcepto",
            params: { id: concepto.id },
          });
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          this.eliminarConcepto(concepto);
        }
      });
    },
    eliminarConcepto(concepto) {
      Swal.fire({
        title: "¿Estás seguro?",
        text: `¿Deseas eliminar ${concepto.descripcion} de manera permanente?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          axios
            .delete("conceptos/" + concepto.id)
            .then((res) => {
              Swal.fire(
                "Eliminado",
                `${res.data.concepto.descripcion} se ha eliminado con éxito.`,
                "success"
              );
              this.$refs.datatable.update();
            })
            .catch((err) => console.log(err))
            .finally(() => (this.loading = false));
        }
      });
    },
  },
};
</script>
